/* src/app/components/doc-viewer-new/doc-viewer-information-bar/doc-viewer-information-bar.component.scss */
.main-container {
  color: rgba(0, 0, 0, 0.87);
  background: #f5f5f5;
}
.temp-icon {
  font-size: 20px;
  color: rgb(36, 62, 144);
  background-color: inherit;
  cursor: pointer;
}
.disabled {
  font-size: 20px;
  color: #a0a0a0;
  background-color: inherit;
  cursor: default;
}
.reviewed-by-node {
  margin-left: 4px;
  margin-right: 8px;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .main-container {
  color: white;
  background: rgba(0, 0, 0, 0.87);
}
:host-context(.dark-theme) .temp-icon {
  color: rgb(255, 193, 7);
}
:host-context(.dark-theme) .disabled {
  color: #575757;
}
:host-context(.dark-theme) .reviewed-by-node {
  color: rgb(255, 193, 7);
}
/*# sourceMappingURL=doc-viewer-information-bar.component.css.map */
